// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.storage.landlordbusinesstypeconfirmation.LandlordBusinessType

export enum LandlordBusinessType {
  COMPANY = 'company',
  INDIVIDUAL = 'individual',
}

export const LandlordBusinessType_values = [LandlordBusinessType.COMPANY, LandlordBusinessType.INDIVIDUAL] as const;
